var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownDarker6Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "67CB901C-3064-46CD-A284-B3CBCDFD86D0_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-890.000000, -111.000000)",
    stroke: "#DD9C00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(566.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(191.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Down_Darker-6px",
    points: "134 9 137 12 140 9"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownDarker6Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Down_Darker-6px.16fd5c7fa2e3929ab490e34368f1d11e.svg";
export { ForwardRef as ReactComponent };